import theme from '../../theme';

// Level 1 is styled once in _commonPageContentStyles. The Scrollspy list is flat, so level 2 is
// told apart by position: `submenus` holds the 1-based li positions that are sub-items. A
// sub-item keeps the level-1 rail at the edge and adds the 1px inner rail 24px in from it.
const navigationStyles = (submenus: number[]) => {
  const submenuStyles = submenus
    .map(
      (submenu) => `
        &:nth-of-type(${submenu}) {
          padding-left: 2.5625rem;

          &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 1.5rem;
            width: 0.0625rem;
            height: 100%;
            background-color: ${theme.neutralBorder};
            transition: background-color 0.3s ease-in-out;
          }

          &.active,
          &:hover {
            border-color: ${theme.neutralBorder};

            &:before {
              background-color: ${theme.primaryBorder};
            }
          }
        }
      `,
    )
    .join('');

  return `
    .page-content .page-navigation {
      .multilevel-link-list {
        li {
          ${submenuStyles}
        }
      }
    }
  `;
};

export default navigationStyles;
